import { UserClaims } from '../../../../common/models/user-claims.interface';

export interface UserAuth {
    jwt: string;
    claims: UserClaims;
    isInternal: boolean;
}

export interface AuthState {
    data: UserAuth;
    ui: {
        showFrame: boolean;
    };
}

export const initialAuthState: AuthState = {
    ui: {
        showFrame: false
    },
    data: {
        jwt: null,
        claims: null,
        isInternal: false
    }
};
